<template>
  <header id="services_navbar">
    <div class="row">
      <nav class="navbar navbar-expand navbar-dark">
        <div class="container-fluid">
          <div class="col-6 d-flex justify-content-start align-items-center px-4">
            <a class="navbar-brand" href="#"><img src="../../assets/Dama-logo-white.svg" alt="Dama logo"></a>
          </div>
          <div class="col-6 d-flex justify-content-end align-items-center nav_title px-4">
            <span class="mx-3 display"> {{ card.title }} </span>
            <span class="mx-3"> / {{$t('services.title')}} </span>
<!--            <router-link :to="'/'">-->
              <img @click="$router.go(-1)" src="../../assets/icons/news_nav_back.svg">
<!--            </router-link>-->
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>

// import i18n from '../../i18n'
// import $ from 'jquery'
import $ from 'jquery'
import Constants from '../../Plugins/Constants'
import ServiceRepository from '../../Repositories/ServiceRepository'

export default {
  name: 'ServicesNavbar',
  data () {
    return {
      id: 0,
      // results: [],
      // numPages: 0,
      // page: 1,
      // per_page: 4,
      card: {
        title: '',
        description: '',
        created_at: '',
        images: []
      },
      baseUrl: Constants.baseUrl,
      ServicesRepo: new ServiceRepository()
    }
  },
  methods: {
    async getSingleServices (id) {
      // console.log('kk', this.section)
      const response = await this.ServicesRepo.getSigleServiceById(id)
      this.card = response.data.body
      // console.log('tata', this.card)
      // console.log('tata', typeof this.card.images)
    }
  },
  created () {
    // this.getPage(1)
    this.id = this.$route.params.newsId
    if (this.id !== 0) {
      this.getSingleServices(this.id)
    }
  },
  mounted () {
    if (localStorage.getItem('lang') === 'ar') {
      $('#services_navbar').css('direction', 'ltr')
    } else {
      $('#services_navbar').css('direction', 'rtl')
      $('#services_navbar .nav_title img').css('transform', 'rotate(180deg)')
    }
  }
}

</script>

<style scoped lang="scss">
@import "src/scss/main";
.disabled_lang {
  color: rgba(255,255,255,0.4)!important;
}
#services_navbar {
  //direction: rtl;
  position: fixed;
  z-index: 500000;
  width: 100%;
  background-color: rgba(0,0,0,0.5) !important;
  backdrop-filter: blur(11px) opacity(1);
  -webkit-backdrop-filter: blur(11px) opacity(1);
  -moz-backdrop-filter: blur(11px) opacity(1);
  -o-backdrop-filter: blur(11px) opacity(1);
}
#services_navbar .navbar-brand img {
  //height: 44.22px;
  //width: 133.36px;
  width: 125.3278px;
  height: 49.5202px;
}
#services_navbar .container-fluid {
  padding: 0;
}
#services_navbar .col-md-4, #services_navbar .col-md-8 {
  padding: 0;
}
#services_navbar .nav_title {
  font-family: Messiri-Bold;
  font-size: 16.5px;
}
#services_navbar .nav_title img {
  width: 21.66px;
  height: 14.08px;
  cursor: pointer;
}
#services_navbar .display {
  display: block;
}
@media screen and (max-width: 576px) {
  //#services_navbar .navbar-brand img {
  //  width: 17vh;
  //  min-width: 17vh;
  //  min-height: 5.5vh;
  //  height: 5.5vh;
  //}
}
@media screen and (max-width: 768px) and (min-width: 576px) {
  //#services_navbar .navbar-brand img {
  //  width: 18.5vh;
  //  min-width: 18.5vh;
  //}
}
@media screen and (max-width: 992px) and (min-width: 768px) {
  //#services_navbar .nav_title {
  //  font-size: 2.7vmin;
  //}
  //#services_navbar .nav_title img {
  //  width: 3.482vmin;
  //  height: 2.334vmin;
  //}
}
@media screen and (max-width: 768px) {
  //#services_navbar .nav_title {
  //  font-size: 3.5vmin;
  //}
  //#services_navbar .nav_title img {
  //  width: 4.282vmin;
  //  height: 3.134vmin;
  //}
  #services_navbar .display {
    display: none;
  }
}
</style>
